import React from 'react'
import { InputGroup } from 'react-bootstrap'
import { _integerRegex_ } from '../../lib/Regex'
import {
  isAllowWarehouseManagement,
  maxWarehouseQty
} from '../../lib/AllStaticVariables'
import { prepareProductName } from '../../lib/AllGlobalFunction'
import { ErrorMessage } from 'formik'
import TextError from '../../components/TextError'

const ManageSizeValues = ({ values, setFieldValue, errors, resetForm }) => {
  const handleSizeValueChecked = ({ pricingDetails, checked }) => {
    const updatedProductPrices = values?.productPrices?.map((data) => {
      if (data?.key === pricingDetails?.key) {
        return {
          ...data,
          mrp: values?.mrp || 0,
          sellingPrice: values?.sellingPrice || 0,
          discount: values?.discount || 0,
          quantity: '',
          manageWarehouseStock: false,
          isCheckedForQty: checked,
          productWarehouses:
            data?.productWarehouses?.length > 0 ? data?.productWarehouses : [],
          marginIn: values?.marginIn ?? 'Absolute',
          marginCost: values?.marginCost ?? 0,
          marginPercentage: values?.marginPercentage ?? 0
        }
      }
      return data
    })

    const checkMultipleSizeSelected =
      updatedProductPrices?.filter((obj) => obj?.isCheckedForQty)?.length || 0
    let productName = values?.productName || []
    if (
      checkMultipleSizeSelected > 1 ||
      (checkMultipleSizeSelected === 1 && values?.isAllowSizeInTitle)
    ) {
      const sizeName =
        checkMultipleSizeSelected === 1
          ? updatedProductPrices.find((obj) => obj.isCheckedForQty)?.sizeName
          : 'size'
      productName = prepareProductName(
        sizeName,
        checkMultipleSizeSelected > 1 ? 3 : values?.titleSequenceOfSize,
        'size',
        { productName: values?.productName },
        checkMultipleSizeSelected === 1
      )
    } else {
      productName = prepareProductName(
        'size',
        3,
        'size',
        { productName: values?.productName },
        false
      )
    }

    values = {
      ...values,
      productName,
      productPrices: updatedProductPrices,
      [pricingDetails?.key]: ''
    }

    resetForm({ values })
  }

  return (
    <div className='col-md-12 mb-3'>
      <label className='form-label required'>Size Value</label>
      <div className='d-flex align-items-center custom_mt_0 gap-4 flex-wrap'>
        {values?.productPrices?.map((pricingDetails) => (
          <InputGroup className='custom_checkbox' key={pricingDetails?.sizeID}>
            <InputGroup.Checkbox
              id='productPrices'
              checked={pricingDetails?.isCheckedForQty}
              onChange={(e) => {
                handleSizeValueChecked({
                  pricingDetails,
                  checked: e?.target?.checked
                })
              }}
            />
            <label className='custom_label' htmlFor={pricingDetails?.sizeID}>
              {pricingDetails?.sizeName}
            </label>
            {!isAllowWarehouseManagement && (
              <input
                disabled={pricingDetails?.isCheckedForQty ? false : true}
                type='text'
                placeholder='Qty'
                value={pricingDetails?.quantity}
                className='form-control custom_textbox'
                onChange={(e) => {
                  const inputValue = e?.target?.value
                  const isValid = _integerRegex_.test(inputValue)
                  if (
                    ((isValid ||
                      (inputValue >= 0 &&
                        inputValue <= maxWarehouseQty &&
                        isValid)) &&
                      !isNaN(inputValue)) ||
                    !inputValue
                  ) {
                    let productPriceList = values?.productPrices ?? []

                    if (productPriceList.length > 0) {
                      productPriceList = productPriceList?.map((data) => {
                        if (data?.sizeID === pricingDetails?.sizeID) {
                          return {
                            ...data,
                            quantity: e?.target?.value
                          }
                        } else {
                          return data
                        }
                      })
                    }
                    setFieldValue('productPrices', productPriceList)
                  }
                }}
              />
            )}
          </InputGroup>
        ))}
      </div>
      {!Array.isArray(errors) && (
        <ErrorMessage name='productPrices' component={TextError} />
      )}
    </div>
  )
}

export default ManageSizeValues
